import React from 'react';
import Box from '@mui/material/Box';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {dataGridSx} from '../constants/styles';

const localeText = {
    toolbarColumns: 'Colonnes',
    toolbarFilters: 'Filtres',
    toolbarDensity: 'Densité',
    toolbarDensityLabel: 'Densité',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Confortable',
    columnsPanelTextFieldLabel: 'Rechercher une colonne',
    columnsPanelTextFieldPlaceholder: 'Titre de colonne',
    columnsPanelShowAllButton: 'Tout afficher',
    columnsPanelHideAllButton: 'Tout masquer',
    filterPanelAddFilter: 'Ajouter un filtre',
    filterPanelDeleteIconLabel: 'Supprimer',
    filterPanelColumns: 'Colonnes',
    filterPanelInputLabel: 'Valeur',
    filterPanelInputPlaceholder: 'Valeur du filtre',
    filterOperatorContains: 'contient',
    filterOperatorEquals: 'égal à',
    filterOperatorStartsWith: 'commence par',
    filterOperatorEndsWith: 'finit par',
    filterOperatorIsEmpty: 'est vide',
    filterOperatorIsNotEmpty: "n'est pas vide",
    filterOperatorIsAnyOf: 'est parmi',
    noRowsLabel: 'Aucune donnée',
    MuiTablePagination: {
        labelRowsPerPage: 'Lignes par page :',
        labelDisplayedRows: ({from, to, count}) => `${from}–${to} sur ${count}`,
    },
};

/**
 * DataGrid MUI affichant les données agrégées par adresse, avec groupes de
 * colonnes colorés par source et barre d'outils (filtre, export, densité…).
 */
export default function ResultGrid({rows, columns, columnGroupingModel}) {
    return (
        <Box sx={{mt: 2, mx: 2, height: 'calc(100vh - 130px)'}}>
            <DataGrid
                rows={rows}
                columns={columns}
                columnGroupingModel={columnGroupingModel}
                slots={{toolbar: GridToolbar}}
                density="compact"
                pageSizeOptions={[25, 50, 100, 200]}
                initialState={{pagination: {paginationModel: {pageSize: 25}}}}
                sx={dataGridSx}
                localeText={localeText}
            />
        </Box>
    );
}

